import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap';

export default class DeleteSavedSearch extends React.Component {
  static propTypes = {
    search: PropTypes.shape({
      name: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired
    }),
    onCancel: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired
  };

  render() {
    const {
      search,
      onCancel,
      onDelete
    } = this.props;

    if (search) {
      return (
        <Modal show={search != null} onHide={onCancel}>
          <Modal.Header closeButton>
            <Modal.Title>Delete Saved Search</Modal.Title>
          </Modal.Header>
          <Modal.Body className="left-buffer-md">
            <div
              className="bottom-buffer-sm"
            >
                You are about to delete your saved search <strong>{search.name}</strong>
            </div>
            <div className="top-buffer-sm">This action is permanent. Are you sure you want to delete?</div>
          </Modal.Body>
          <Modal.Footer>
            <button className='btn btn-sm btn-cancel' onClick={onCancel}>Cancel</button>
            <button className='btn btn-sm btn-danger' onClick={onDelete}>Delete</button>
          </Modal.Footer>
        </Modal>
      );
    } else {
      return null;
    }
  }
}
